import React, { Component } from 'react';

import {Card, CardText} from 'material-ui/Card';
import RaisedButton from 'material-ui/RaisedButton';
import Dialog from 'material-ui/Dialog';
import DatePicker from 'material-ui/DatePicker';
import CustomTimePicker from '../elements/CustomTimePicker';

import moment from 'moment';

import Util from '../../Util';
import Config from '../../conf';

import {WashDetails as styles} from './form.css';

const washTypes = Config.WASH_TYPES;

class ChooseType extends Component {

  constructor(props) {
    super(props);

    this.state = {
      timeDialogOpen: false,
      timeMessage: '',
    }

    this.selectWash = this.selectWash.bind(this);
    this.formatDate = this.formatDate.bind(this);
    this.shouldDisableDate = this.shouldDisableDate.bind(this);
    this.openTimeDialog = this.openTimeDialog.bind(this);

    this.closeDialog = this.closeDialog.bind(this);
    this.fieldChanged = this.fieldChanged.bind(this);
    this.updateDate = this.updateDate.bind(this);
    this.nextDisabled = this.nextDisabled.bind(this);
  }

  componentDidMount() {
    // TODO move to Home.js
  }

  fieldChanged(fieldName, newValue) {
    this.props.setHasError(fieldName, false);
    this.props.updateField(fieldName, newValue);
  }

  formatDate(date) {
    if (!date) return '';
    return Util.monthToString(date.getMonth()) + ' ' + date.getDate() + ', ' + date.getFullYear();
  }

  shouldDisableDate(date) {
    const minDate = moment().add(1, 'day');
    const maxDate = minDate.clone().add(1, 'month').subtract(1, 'day');

    const momentDate = moment(date);
  
    let valid = true;

    if (momentDate.isBefore(minDate)) valid = false;
    if (momentDate.isAfter(maxDate)) valid = false;
    if (momentDate.clone().format('dddd') === 'Sunday' || momentDate.clone().format('dddd') === 'Saturday') valid = false;
    
    // Should disable date ie. if it is valid then it should not be disabled
    return !valid;
  }

  selectWash(washType) {
    this.props.updateField('washType', washType.name.replace(/[^a-zA-Z]/g, ''));
    this.props.updateField('washTypeDisplay', washType.displayName);

    let extraWashPrice = 0;
    if (this.props.details.carType.toUpperCase() === 'SUV') {
      extraWashPrice = 10;
    } else if (this.props.details.carType.toUpperCase() === 'VAN') {
      extraWashPrice = 20;
    }
    this.props.updateField('washPrice', this.props.details.washDetails[washType.name].cost + (extraWashPrice));

    this.setState({
      timeDialogOpen: true
    });
  }

  nextDisabled() {
    let ret = !this.props.details.time ||
              !this.props.details.startTime ||
              !this.props.details.endTime ||
              !this.props.details.washType;

    return ret;
  }

  openTimeDialog() {
    // check that the time is far enough in the future to book
    const date = this.props.details.date;
    const timeSplit = this.props.details.time.split(' to ');
    const startTime = Util.toHoursMinutes(timeSplit[0]);

    const body = {
      date: {
        d: date.getDate(),
        m: date.getMonth(),
        y: date.getFullYear()
      },
      startTime: {
        h: startTime.hours,
        m: startTime.mins
      }
    };

    fetch(Config.BACKEND_API_URL + 'booking/time', {
      method: 'post',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(body)
    }).then((response) => {
      return response.json();
    }).then((data) => {
      if (data.result === true) {
        this.props.next();
      } else {
        // not enough time
        this.setState({
          timeMessage: data.message ? data.message : 'An unexpected error occurred. Please try again.',
          timeDialogOpen: true
        });
      }
    }).catch((err) => {
      console.log('Failed to check booking start time', err);
    });
  }

  updateDate(fieldName, newValue) {
    this.fieldChanged('time', 'Select Time');
    this.fieldChanged('startTime', '');
    this.fieldChanged('endTime', '');
    this.fieldChanged(fieldName, newValue);
  }

  complete() {
    this.closeDialog();
    this.props.next();
  }

  closeDialog() {
    this.setState({
      timeDialogOpen: false
    });
  }

  render() {
    const actions = [
      <RaisedButton
        label="Cancel"
        primary={false}
        onTouchTap={() => this.closeDialog()}
        style={styles.dialogButton}
      />,
      <RaisedButton
        label="Confirm"
        primary={true}
        onTouchTap={() => this.complete()}
        disabled={this.nextDisabled()}
        style={styles.dialogButton}
      />
    ];

    let extraWashPrice = 0;
    if (this.props.details.carType.toUpperCase() === 'SUV') {
      extraWashPrice = 10;
    } else if (this.props.details.carType.toUpperCase() === 'VAN') {
      extraWashPrice = 20;
    }

    return (
      <div style={styles.center}>
        {this.props.details.isSmallScreen && <h2 style={styles.title}>Choose Your Wash</h2>}
          <div style={styles.flexContainer}>
          {washTypes.map((washType, idx) => {
            return (
              <Card
                style={styles.cardContainer}
                key={washType.name}
              >
                <h2 style={styles.cardTitle}>{washType.displayName}</h2>
                <CardText
                  style={styles.card}
                >
                  <ul style={styles.list}>
                  {washType.points.map((point, idx) => {
                    return (
                      <li key={idx} style={styles.li}>{point}</li>
                    );
                  })}
                  </ul>
                </CardText>
                <div style={styles.priceText}>
                  ${(this.props.details.washDetails[washType.name].cost + (extraWashPrice)).toFixed(2)}
                </div>
                <RaisedButton
                  label="Select"
                  secondary={true}
                  style={styles.chooseButton}
                  onClick={() => this.selectWash(washType)}
                />
              </Card>
            );
          })}
          </div>
          <Dialog 
            title="Select Time Options"
            actions={actions}
            modal={false}
            open={this.state.timeDialogOpen}
            onRequestClose={this.closeDialog}
            bodyStyle={styles.center}
            titleStyle={styles.center}
            className="counteract-zoom"
          >
            <h3>Date and Time</h3>

            <DatePicker
              mode={this.props.details.isSmallScreen ? 'portrait' : 'landscape'}
              hintText="Select Date"
              autoOk={true}
              formatDate={this.formatDate}
              shouldDisableDate={this.shouldDisableDate}
              style={styles.inputStyle}
              inputStyle={styles.inputStyle}
              textFieldStyle={styles.inputStyle}
              hintStyle={styles.hintStyle}
              floatingLabelText={this.props.details.date ? 'Date' : ''}
              value={this.props.details.date}
              onChange={(evt, date) => this.updateDate('date', date)}
              errorText={this.props.details.dateError ? 'Please select a date' : ''}
            />

            <CustomTimePicker
              details={this.props.details}
              fieldChanged={this.fieldChanged}
              floatingLabelText={this.props.details.time ? 'Time' : ' '}
            />
          </Dialog>
          <RaisedButton style={styles.backButton}
            label="Back" primary={true} onClick={this.props.back} />
      </div>
    );
  }
}

export default ChooseType;



// WEBPACK FOOTER //
// ./src/app/components/form/WashDetails.js